export namespace MapStyles {
  export const SATELLITE =
    'mapbox://styles/mapbox/satellite-streets-v12' as const;
  export const NAV = 'mapbox://styles/mapbox/navigation-night-v1' as const;
  export const DARK = 'mapbox://styles/mapbox/dark-v11' as const;
  export const STREETS = 'mapbox://styles/mapbox/streets-v12' as const;
}
